import React from 'react';
import { motion } from 'framer-motion';
import { HardHat, Wrench, Ruler, Home } from 'lucide-react';

const HeroSliderSkeleton = () => {
  const icons = [
    { icon: HardHat, delay: 0 },
    { icon: Wrench, delay: 0.2 },
    { icon: Ruler, delay: 0.4 },
    { icon: Home, delay: 0.6 },
  ];

  return (
    <div className="relative h-screen bg-gray-900 flex flex-col items-center justify-center text-white overflow-hidden">
      {/* Animated background */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-shine" />
        <div className="absolute inset-0 pattern-dots opacity-10" />
      </div>
      
      <div className="relative z-10 flex flex-col items-center justify-center text-center p-4">
        {/* Animated Icons */}
        <div className="flex space-x-8 mb-8">
          {icons.map(({ icon: Icon, delay }) => (
            <motion.div
              key={delay}
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{
                delay,
                duration: 0.5,
                repeat: Infinity,
                repeatType: 'reverse',
                repeatDelay: 2,
              }}
            >
              <Icon className="w-10 h-10 md:w-12 md:h-12 text-primary-400" />
            </motion.div>
          ))}
        </div>

        {/* Loading Text */}
        <motion.h2
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          className="text-xl md:text-2xl font-bold font-display mb-4 text-shadow-glow"
        >
          Crafting your experience...
        </motion.h2>

        {/* Progress Bar */}
        <div className="w-64 max-w-full h-1 bg-gray-700 rounded-full overflow-hidden">
          <motion.div
            className="h-full bg-primary-500"
            initial={{ width: '0%' }}
            animate={{ width: '100%' }}
            transition={{ duration: 1.5, repeat: Infinity, ease: 'linear' }}
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSliderSkeleton;
